export const defaultValues = {
  daysPerYear: 365,
  minutesPerHour: 60,
  hoursPerShift: 8,
  tasksPerStorePerDay: 30,
  minutesPerTaskPlacement: 0.5,
  skusPerStorePerDay: 100,
  minutesPerSkuRepositioning: 0.2,
  minutesSavedPerTask: 1,
  minutesSavedPerHandover: 15,
  minutesSavedPerSkuSearch: 30,
  initialSetupCostPerStore: 1500,
  annualDomainMaintenancePerStore: 1000,
  cactusAiMonthlyCostPerStore: 300, // Default value
  cloudCostsPercentage: 0.1 // Make sure this is not 0
};